module.exports = __webpack_public_path__ + "img/user.2ee2b573.png";